module.exports = __webpack_public_path__ + "static/media/ahi-pi-high-risk.c57cf2a1.svg";